import React from "react";
import { Box, Chip, Grid, Paper, Switch, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { groupByCategory, hasModuleId } from "../../utils/bundle-modules";

// The full module catalogue as clickable cards, grouped by category. One grid for the
// approval wizard and the company bundle dialog: both now show EVERY module with the chosen
// bundle's modules switched on, so the grid is the same widget twice — not two copies of it.
const useStyle = makeStyles((theme) => ({
  moduleCard: {
    padding: theme.spacing(1.5),
    height: "100%",
    cursor: "pointer",
    border: "1px solid rgba(0,0,0,.12)",
  },
  moduleCardOn: {
    padding: theme.spacing(1.5),
    height: "100%",
    cursor: "pointer",
    border: "1px solid rgba(0,0,0,.12)",
    borderColor: theme.palette.primary.main,
    backgroundColor: "rgba(25,118,210,.08)",
  },
  badge: {
    marginLeft: theme.spacing(0.5),
  },
}));

export default function ModuleSwitchGrid({
  moduleListing,
  moduleIds,
  onToggle,
  disabled,
}) {
  const classes = useStyle();

  return (
    <>
      {groupByCategory(moduleListing).map(([category, mods]) => (
        <Box key={category} mb={2}>
          <Typography variant="overline" color="textSecondary">
            {category}
            {" "}
            {mods.filter((m) => hasModuleId(moduleIds, m.id)).length}
            {" of "}
            {mods.length}
            {" on"}
          </Typography>
          <Grid container spacing={1}>
            {mods.map((m) => {
              const on = hasModuleId(moduleIds, m.id);
              return (
                <Grid item xs={12} sm={6} key={m.id}>
                  <Paper
                    variant="outlined"
                    className={on ? classes.moduleCardOn : classes.moduleCard}
                    onClick={disabled ? undefined : () => onToggle(m.id)}
                  >
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Box>
                        <Typography variant="body2">
                          {m.name}
                          {m.tier === "addon" && (
                            <Chip size="small" label="add-on" className={classes.badge} />
                          )}
                          {m.tier === "client" && (
                            <Chip size="small" label="client" className={classes.badge} />
                          )}
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          {m.description}
                        </Typography>
                      </Box>
                      {/* readOnly, not onChange: the whole card is the hit area. */}
                      <Switch checked={on} readOnly disabled={disabled} />
                    </Box>
                  </Paper>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      ))}
    </>
  );
}

ModuleSwitchGrid.propTypes = {
  moduleListing: PropTypes.array,
  moduleIds: PropTypes.array,
  onToggle: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
